import React, { useState, useEffect } from 'react';
import { ReviewItem } from '@/types/api';
import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from '@/components/atoms/Carousel';
import { X } from 'lucide-react';
import { PaginationIndicator } from '@/pages/NewsBriefing/_components/PaginationIndicator';

const ImageDialog = ({ review }: { review: ReviewItem }) => {
  const [open, setOpen] = useState(false);
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCurrent(api.selectedScrollSnap());
    api.on('select', () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  // open이 true가 될 때마다 캐러셀을 current로 이동
  useEffect(() => {
    if (open && api) {
      api.scrollTo(current, true); // 애니메이션 없이 즉시 이동
    }
  }, [open, api]);

  const handleOpen = (idx: number) => {
    setCurrent(idx);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="flex gap-[10px]">
        {review.AttachmentList.map((url, i) => (
          <img
            key={i}
            src={url}
            alt="리뷰 이미지"
            className="h-[40px] w-[40px] cursor-pointer rounded-[4px] border border-gr-100 object-cover"
            onClick={() => handleOpen(i)}
          />
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          noCloseBtn
          className=" flex w-fit max-w-[480px] flex-col gap-0 bg-gr-50 p-0 shadow-none"
        >
          <div className=" flex h-[32px]  w-full items-center justify-end px-[12px]">
            <button onClick={handleClose} className="">
              <X className="h-[24px] w-[24px]" />
            </button>
          </div>
          <Carousel opts={{ loop: true }} setApi={setApi}>
            <CarouselContent className="">
              {review.AttachmentList.map((url, i) => (
                <CarouselItem key={url}>
                  <div className="flex h-full w-full flex-col items-center justify-center bg-gr-50 ">
                    <img
                      src={url}
                      className="max-h-[480px] max-w-[480px]"
                      alt={`리뷰 이미지 ${i + 1}`}
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            {review.AttachmentList.length > 1 && (
              <>
                <CarouselPrevious className="-left-5" />
                <CarouselNext className="-right-5" />
              </>
            )}
          </Carousel>
          <div className="flex h-[28px] w-full items-center justify-center">
            {review.AttachmentList.length > 1 && (
              <PaginationIndicator
                total={review.AttachmentList.length}
                currentIndex={current}
                onDotClick={(index) => api?.scrollTo(index)}
                isDashboard
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageDialog;
